import { render, staticRenderFns } from "./ModalFaqNew.vue?vue&type=template&id=505eb015&"
import script from "./ModalFaqNew.vue?vue&type=script&lang=js&"
export * from "./ModalFaqNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports